(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.site-header__mobile-menu > summary').forEach((summary) => {
    const menu = summary.parentElement;

    if (!(menu instanceof HTMLDetailsElement)) return;

    const syncExpandedState = () => {
      summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    };

    summary.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      menu.open = !menu.open;
      syncExpandedState();
    });

    menu.addEventListener('toggle', syncExpandedState);
    syncExpandedState();
  });

  } catch(e) { console.error(e); }
})();
})();
